/*
  The first field a dialog or sheet should open on. Their close button leads the tab order where
  the prototype draws it, in the head, but opening on it would make every form wait for a Tab
  before typing. So opening skips it, as Radix already skips links, and lands on the first real
  control, or nowhere special when there is none.
*/
const TABBABLE =
    'input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

function firstField(container: HTMLElement): HTMLElement | null {
    for (const element of container.querySelectorAll<HTMLElement>(TABBABLE)) {
        // The close button carries data-close-button (Sheet, banded Dialog).
        if (element.closest('[data-close-button]')) continue;
        if (element.tabIndex < 0) continue;
        // Hidden controls are not candidates. jsdom has no checkVisibility, and no layout either.
        if (typeof element.checkVisibility === 'function' && !element.checkVisibility()) continue;
        return element;
    }
    return null;
}

/**
 * An onOpenAutoFocus that lands on the first field instead of the close button. Leaves Radix to
 * it when the caller already took over, or when there is no field.
 */
export function focusFirstField(event: Event): void {
    if (event.defaultPrevented || !(event.currentTarget instanceof HTMLElement)) return;
    const field = firstField(event.currentTarget);
    if (field) {
        event.preventDefault();
        field.focus({ preventScroll: true });
    }
}
